import {pointQuery} from "./requests";
import {IDS, NAMES} from "../area-reports/layers";
import {default as pointLayer} from "../../notebooks/point-layer";
import LucExtendedReport from './LucExtendedReport.svelte';
import LucMain from './luc/LucMain.svelte';
import LucMap from './luc/LucMap.svelte';

const SUMMARY = 'summary';

function defaultViews(aReport, layerName, layerId, extras = {}) {
    const {request, retryStore} = pointQuery(aReport, layerName, layerId);
    const overrides = new Map([['pointData', request]]);
    const cells = ['report'];

    return [
        {
            title: SUMMARY,
            notebook: pointLayer,
            cells,
            overrides,
            extraClass: 'point-report-notebook',
            retry: retryStore,
            ...extras
        }
    ]
}

export function lucExtended(aReport) {
    const {request, retryStore} = pointQuery(aReport, NAMES.LUC_EXTENDED, IDS.LUC_EXTENDED);

    return [
        {
            uuid: '39376b0a-efef-42c4-aa54-9bb795d82616',
            notebookViews: [
                {
                    id: 'luc-main',
                    title: 'nzluc-unit',
                    component: LucMain,
                    props: {
                        request
                    },
                    retry: retryStore
                }
            ]
        },
        /*{
            uuid: '39376b0a-efef-42c4-aa54-9bb795d82617',
            notebookViews: [
                {
                    id: 'legacy-regional-legends',
                    title: 'Legacy Regional Legends',
                    component: LegacyRegionalLegends,
                    props: {
                        request,
                        report: aReport
                    },
                    retry: retryStore
                }
            ]
        },*/
        {
            uuid: '39376b0a-efef-42c4-aa54-9bb795d82618',
            notebookViews: [
                {
                    id: 'luc-map',
                    title: 'With regional',
                    component: LucMap,
                    props: {
                        request,
                        report: aReport
                    },
                    retry: retryStore
                }
            ]
        }
    ]

    return [
        /*{
            id: 'national-only',
            title: 'National Only',
            // component: LucExtendedReport,
            props: {
                request,
                report: aReport
            },
            retry: retryStore
        },*/
        {
            id: 'national-and-regional',
            title: 'With regional',
            component: LucExtendedReport,
            props: {
                request,
                report: aReport,
                showRegionalLegends: true
            },
            retry: retryStore
        }
    ]
}

export function pinReportTopics(report) {
    return [
        {
            title: 'Landscape',
            topics: [
                {
                    title: 'Direction of slope (Aspect)',
                    id: 'ef34af96-791e-4bea-9f0e-27f0594051ee',
                    sections: [
                        {
                            uuid: '951cf965-72c4-4ce5-a4f4-cb87907e2318',
                            notebookViews: defaultViews(report, NAMES.SLOPE_ASPECT, IDS.SLOPE_ASPECT)
                        }
                    ]
                },
                {
                    title: 'Steepness of Slope',
                    id: '7768197a-bc2a-470b-ada9-eda9403466ac',
                    sections: [
                        {
                            uuid: 'a35a15b9-c576-45fe-a5f5-41200300ced1',
                            notebookViews: defaultViews(report, NAMES.SLOPE_STEEPNESS, IDS.SLOPE_STEEPNESS)
                        }
                    ]
                },
                {
                    id: '6852437c-f3e3-459f-9119-4bb2915a6728',
                    title: 'Erosion Severity (Observed)',
                    sections: [
                        {
                            uuid: 'b359ddbb-71ec-440d-b4ad-5b4e5f08cffc',
                            notebookViews: defaultViews(report, NAMES.EROSION, IDS.EROSION)
                        }
                    ]
                },
                {
                    id: '5b077c0c-dd65-4b95-9e3e-14969405ad7c',
                    title: 'Surface Rock Type',
                    sections: [
                        {
                            uuid: 'c9132be1-4a26-4998-b72b-197f45bd52b9',
                            notebookViews: defaultViews(report, NAMES.SURFACE_ROCK, IDS.SURFACE_ROCK)
                        }
                    ]
                }
            ]
        },
        {
            title: 'Land Capability',
            topics: [
                {
                    id: 'd8c9f5ac-7f1c-4526-beec-29c1ba8dea36',
                    title: 'Land Use Capability',
                    sections: lucExtended(report) /*[
                        {
                            uuid: '39376b0a-efef-42c4-aa54-9bb795d82616',
                            notebookViews: lucExtended(report)
                        }
                    ]*/
                },
                {
                    id: "7d3a116a-97ed-4ce4-9a45-331fc6b2db9b",
                    title: "Baseline Highly Productive Land",
                    sections: [
                        {
                            uuid: "cf06e2d4-01d3-495d-8b92-56e8dc744a20",
                            notebookViews: defaultViews(report, NAMES.LRI_HPL, IDS.LRI_HPL_LAND)
                        },
                    ]
                },
                {
                    id: 'a1740420-1776-4bcd-a8c0-bcdb8bc408a3',
                    title: 'Suitability for Arable Cropping',
                    sections: [
                        {
                            uuid: 'a144c0c3-235b-413f-a75d-09b6218ee37e',
                            notebookViews: defaultViews(report, NAMES.ARABLE_SUITABILITY, IDS.ARABLE_SUITABILITY)
                        }
                    ]
                },
                {
                    id: '28379e52-85c3-410b-9703-c42341be5c2e',
                    title: 'General Suitability',
                    sections: [
                        {
                            uuid: 'd90fdd6e-b5d8-4522-aefa-3fd3e4da994a',
                            notebookViews: defaultViews(report, NAMES.GENERAL_SUITABILITY, IDS.GENERAL_SUITABILITY)
                        }
                    ]
                },
                {
                    id: '0a099ce5-9750-4e96-ada6-26c72b00b1d2',
                    title: 'Suitability for Production Forestry',
                    sections: [
                        {
                            uuid: '7fac687b-72b4-4e2f-b565-ffcd8eb25140',
                            notebookViews: defaultViews(report, NAMES.PROD_FOR_SUITABILITY, IDS.PROD_FOR_SUITABILITY)
                        }
                    ]
                },
                {
                    'id': 'cfd7ba3d-5395-4574-9b1c-a9b55bcc024c',
                    'title': 'Most intensive, sustainable land use possible',
                    sections: [
                        {
                            uuid: 'ae4f98db-389d-4065-a18a-060459c624f3',
                            notebookViews: defaultViews(report, NAMES.LRI_PHYS_SUSTAIN, IDS.LRI_PHYS_SUSTAIN)
                        },
                    ]
                }
            ]
        },
        {
            title: 'Habitats',
            topics: [
                {
                    'id': 'c0165ff6-cd28-429d-b05d-990afadcdf96',
                    title: 'Protected Areas Network',
                    sections: [
                        {
                            uuid: '6426cba4-9c13-4855-ad4b-8bf728f59000',
                            notebookViews: defaultViews(report, NAMES.PROT_AREA_NET, IDS.PROT_AREA_NET)
                        }
                    ]
                },
                {
                    id: '6a6cd326-3742-4fe1-9bdc-a4f6b957b526',
                    title: 'Threatened Environment Classification',
                    sections: [
                        {
                            uuid: '76956174-b61a-4879-8243-b6f31a525bd5',
                            notebookViews: defaultViews(report, NAMES.LENZ_TEC, IDS.LENZ_TEC)
                        }
                    ]
                },
                {
                    'id': 'b5c01f73-9107-4d86-8b76-06e3ecd2e3fe',
                    'title': 'Potential Natural Vegetation',
                    sections: [
                        {
                            uuid: 'fb977e77-f856-4a21-8c23-c4313b5680e9',
                            notebookViews: defaultViews(report, NAMES.POT_NAT_VEG, IDS.POT_NAT_VEG)
                        }
                    ]
                },
                {
                    'id': 'd87bca6d-9aca-456f-8792-a428dd5f3c2e',
                    'title': 'Vegetation',
                    sections: [
                        {
                            uuid: 'e29dc242-4b24-42f4-97c6-a0711bb32aa9',
                            notebookViews: defaultViews(report, NAMES.VEG, IDS.VEG)
                        }
                    ]
                },
                {
                    'id': '921470f0-72bb-478e-a760-66e6372e28f0',
                    'title': 'Wetlands',
                    sections: [
                        {
                            uuid: '4546ad02-7e52-4530-a959-bd53dce90e30',
                            title: 'Pre-human Wetlands',
                            notebookViews: defaultViews(report, NAMES.WETLANDS_HISTORIC, IDS.WETLANDS_HISTORIC)
                        },
                        {
                            uuid: 'f37f2412-cf46-4f63-822a-72e9f4556adc',
                            'title': 'Current Wetlands',
                            notebookViews: defaultViews(report, NAMES.WETLANDS_CURRENT, IDS.WETLANDS_CURRENT)
                        }
                    ]
                }
            ]
        },
        {
            "id": "33beede7-b6fc-460b-9551-939e8b744f1c",
            "title": "Ecosystem Characteristics",
            "topics": [
                {
                    'id': 'c04601b0-d1fb-44ca-bf63-b0325df1aa7d',
                    'title': 'Basic Ecosystems (2002-2008)',
                    sections: [
                        {
                            uuid: 'dce0f7da-59b8-418b-9c73-6ffc7023c90e',
                            notebookViews: defaultViews(report, NAMES.BASIC_ECOSYS, IDS.BASIC_ECOSYS)
                        }
                    ]
                },
                {
                    'id': '3622521d-2cd6-4450-a5c2-b2897911d2f1',
                    'title': 'Water Yield (2012)',
                    sections: [
                        {
                            uuid: '348eb883-f847-4ada-aa87-e9ce0b248cda',
                            notebookViews: defaultViews(report, NAMES.ECOSYS_WATER_YIELD, IDS.ECOSYS_WATER_YIELD)
                        }
                    ]
                },
                {
                    "id": "670e7d2b-e266-448a-9879-a6bea3b0e239",
                    "title": "Sediment Lost (2012)",
                    sections: [
                        {
                            uuid: 'bffd2b62-01a6-45dc-a541-743dca906675',
                            notebookViews: defaultViews(report, NAMES.ECOSYS_SEDTLOST, IDS.ECOSYS_SEDTLOST)
                        }
                    ]
                },
                {
                    "id": "83cacef0-0c6a-4f1a-853f-85368d31a7f0",
                    "title": "Sediment Retained (2012)",
                    sections: [
                        {
                            uuid: '14667185-5237-4615-8704-6e72bc253f71',
                            notebookViews: defaultViews(report, NAMES.ECOSYS_SEDTRETAINED, IDS.ECOSYS_SEDTRETAINED)
                        }
                    ]
                },
                {
                    "id": "04f1e8d4-ae5a-4e34-b1c5-29d38458e174",
                    "title": "Nitrogen loss susceptibility",
                    "layerId": 322,
                    "layerName": "eswwo_susceptibility_to_n_loss_vert",
                    "sections": [{
                        "uuid": "df538e27-6ac9-41db-8e81-e373d5f497ea",
                        "notebookViews": defaultViews(report, 'eswwo_susceptibility_to_n_loss_vert', 322)
                    }]
                },
                {
                    "id": "a74435d2-1510-4b82-af7d-b98ceace1e3a",
                    "title": "Phosphorous loss susceptibility",
                    "layerId": 321,
                    "layerName": "eswwo_susceptibility_to_n_loss_horiz",
                    "sections": [{
                        "uuid": "ce29a78e-f84b-4ca1-bbe9-e1e20741a617",
                        "notebookViews": defaultViews(report, 'eswwo_susceptibility_to_n_loss_horiz', 321)
                    }]
                }]
        },
        {
            title: "Crop Suitability",
            topics: [
                {
                    id: "7dd140c2-c032-45d0-afa6-08d947387ffa",
                    title: "Apple Suitability Score",
                    "sections": [
                        {
                            "uuid": "0f898d8c-f2bc-4960-9cf8-524bc9c01f8a",
                            "notebookViews": defaultViews(report, "apple_suitability_score", 291),
                        }
                    ]
                },
                {
                    "id": "3db5a1d8-b697-4374-8ed0-6ba8a972fc22",
                    "title": "Avocado Suitability Score",
                    "sections": [
                        {
                            "uuid": "cee58ab1-ec65-4717-a2e9-7d54589f42a7",
                            "notebookViews": defaultViews(report, "avocado_suitability_score", 292),
                        }
                    ]
                },
                {
                    "id": "9a931b9a-4b30-4751-ba0d-b013e2d5c806",
                    "title": "Blueberry Suitability Score",
                    "sections": [
                        {
                            "uuid": "cdd44ef0-113b-4830-8159-5f6b98af7f57",
                            "notebookViews": defaultViews(report, "blueberry_suitability_score", 293),
                        }
                    ]
                },
                {
                    "id": "24f26e93-12d9-4677-83cc-174e402b3492",
                    "title": "Cherry Suitability Score",
                    "sections": [
                        {
                            "uuid": "4f3b6952-6a44-4325-b892-94d1514fec60",
                            "notebookViews": defaultViews(report, "cherry_suitability_score", 294),
                        }
                    ]
                },
                {
                    "id": "d04dcf22-6982-4260-b185-ac539d1c9bf6",
                    "title": "Chestnuts Suitability Categories",
                    "sections": [
                        {
                            "uuid": "1bbecbdb-25b6-449c-994b-6ad1407b172f",
                            "notebookViews": defaultViews(report, "chestnuts_suitability_categories", 295),
                        }
                    ]
                },
                {
                    "id": "42c9642e-7ae7-4baa-932c-56aab8a30954",
                    "title": "Citrus Suitability Categories",
                    "sections": [
                        {
                            "uuid": "dfb362d5-73bf-4a10-bb3a-19d3c37dfe95",
                            "notebookViews": defaultViews(report, "citrus_suitability_categories", 296),
                        }
                    ]
                },
                {
                    "id": "cac4579c-133a-4fa0-973a-44c1a92cb07a",
                    "title": "Douglas Fir Suitability Categories",
                    "sections": [
                        {
                            "uuid": "98c667d5-786e-4125-b9c1-9ba847ab5c5e",
                            "notebookViews": defaultViews(report, "douglas_fir_suitability_categories", 297),
                        }
                    ]
                },
                {
                    "id": "dbf5da01-febc-44be-9415-59035f8d47a1",
                    "title": "Eucalyptus Fastigata Suitability Categories",
                    "sections": [
                        {
                            "uuid": "4cd40f1b-faf3-4fb2-b477-c1fafdf05022",
                            "notebookViews": defaultViews(report, "eucalyptus_fastigata_suitability_categories", 298),
                        }
                    ]
                },
                {
                    "id": "320365a8-3ba5-479f-8b4d-50a1a365223b",
                    "title": "Honey Manuka Suitability Categories",
                    "sections": [
                        {
                            "uuid": "483de543-812c-475a-adf3-2cf20c2b1840",
                            "notebookViews": defaultViews(report, "honey_manuka_suitability_categories", 299),
                        }
                    ]
                },
                {
                    "id": "b0e94b35-11bb-4667-a10a-8d06a1f328ac",
                    "title": "Hops Suitability Categories",
                    "sections": [
                        {
                            "uuid": "4259e4ac-77d6-40bf-9d95-e18ee749429f",
                            "notebookViews": defaultViews(report, "hops_suitability_categories", 300),
                        }
                    ]
                },
                {
                    "id": "edeb7b01-e78e-43f2-aab6-6b6733a6eca2",
                    "title": "Kiwifruit Suitability Score",
                    "sections": [
                        {
                            "uuid": "7969c8a6-4d9c-47cb-9a73-0d288c017cfe",
                            "notebookViews": defaultViews(report, "kiwifruit_suitability_score", 301),
                        }
                    ]
                },
                {
                    "id": "4453c9d9-d39f-4ce7-aad7-ed358836ee7f",
                    "title": "Macadamia Suitability Categories",
                    "sections": [
                        {
                            "uuid": "f5d2a8ab-bddf-43da-b729-f847d51a2f66",
                            "notebookViews": defaultViews(report, "macadamia_suitability_categories", 302),
                        }
                    ]
                },
                {
                    "id": "14d150a0-a66d-4110-b61c-929144ead706",
                    "title": "Maize Grain Suitability Categories",
                    "sections": [
                        {
                            "uuid": "c7a18f1d-6516-4309-b7b8-ec5da1779122",
                            "notebookViews": defaultViews(report, "maize_grain_suitability_categories", 303),
                        }
                    ]
                },
                {
                    "id": "84f0174a-06fe-4b5b-84b7-f075507f46dc",
                    "title": "Onions Suitability Categories",
                    "sections": [
                        {
                            "uuid": "cff57169-4f5c-4b5d-97a7-9486162e24ba",
                            "notebookViews": defaultViews(report, "onions_suitability_categories", 304),
                        }
                    ]
                },
                {
                    "id": "875b3d97-5112-44dd-80ec-cf11d197f784",
                    "title": "Peas Suitability Categories",
                    "sections": [
                        {
                            "uuid": "2c43b6ac-9990-4a1e-8ee9-fca359c33865",
                            "notebookViews": defaultViews(report, "peas_suitability_categories", 305),
                        }
                    ]
                },
                {
                    "id": "adbfa97e-d218-406b-87b5-5df025374035",
                    "title": "Potatoes Suitability Categories",
                    "sections": [
                        {
                            "uuid": "5db3752b-196f-460e-94d1-0c1b65623c1f",
                            "notebookViews": defaultViews(report, "potatoes_suitability_categories", 306),
                        }
                    ]
                },
                {
                    "id": "c7bae456-3df3-4ca1-ab70-6ba3cae20d3f",
                    "title": "Radiata Pine Suitability Categories",
                    "sections": [
                        {
                            "uuid": "49485a57-f586-4a41-99d7-b7a6ce33926d",
                            "notebookViews": defaultViews(report, "radiata_pine_suitability_categories", 307),
                        }
                    ]
                },
                {
                    "id": "b60cd75f-9586-4202-8d9e-c68a5d39bb7b",
                    "title": "Truffles Suitability Categories",
                    "sections": [
                        {
                            "uuid": "dc0ec8a2-f1db-48dd-a5f5-67f3002dbb26",
                            "notebookViews": defaultViews(report, "truffles_suitability_categories", 308),
                        }
                    ]
                },
                {
                    "id": "2b9185cf-5357-4d23-b551-1adc021ecb49",
                    "title": "Wheat Barley And Oats Suitability Categories",
                    "sections": [
                        {
                            "uuid": "5cf027eb-f581-4d5d-9bb6-fd11ee464c6c",
                            "notebookViews": defaultViews(report, "wheat_barley_and_oats_suitability_categories", 309),
                        }
                    ]
                },
                {
                    "id": "af28d44d-ba1e-420c-b202-015a67f090cf",
                    "title": "Wine Grape Pinot Noir Suitability Score",
                    "sections": [
                        {
                            "uuid": "41e4703c-ae62-439e-86ef-fd2a54957c42",
                            "notebookViews": defaultViews(report, "wine_grape_pinot_noir_suitability_score", 310),
                        }
                    ]
                },
                {
                    "id": "387950aa-d6f5-43ea-868a-45324d042f18",
                    "title": "Wine Grape Sauvignon Blanc Suitability Score",
                    "sections": [
                        {
                            "uuid": "e08854d3-3418-4c2d-84fa-11c24aec2bb2",
                            "notebookViews": defaultViews(report, "wine_grape_sauvignon_blanc_suitability_score", 311),
                        }
                    ]
                }
            ]
        },
        {
            "id": "9bfacf73-1d14-433f-8951-f41b6bf91772",
            "title": "Agricultural Impacts",
            "topics": [
                {
                    "id": "06c72872-cba1-4052-8f50-35d334a752cf",
                    "title": "Nitrate Leaching (2015)",
                    sections: [
                        {
                            uuid: "92d7f534-a972-4414-a3a3-f7694a79d57c",
                            notebookViews: defaultViews(report, NAMES.ECOSYS_NITRATE, IDS.ECOSYS_NITRATE)
                        }
                    ]
                },
                {
                    'id': 'a9756de6-b01a-490f-8588-9a416c1560b4',
                    'title': 'Greenhouse gas emission (2010-2016)',
                    sections: [
                        {
                            uuid: "719cb2ce-5e29-4953-ab6c-a223feeca5a1",
                            notebookViews: defaultViews(report, NAMES.ECOSYS_GHG, IDS.ECOSYS_GHG)
                        }
                    ]
                },
                {
                    "id": "8a8f28bf-caea-433f-8133-424734defccb",
                    "title": "Dairy N₂O emissions ",
                    "layerId": 313,
                    "layerName": "eswwo_dairy_max_n2o",
                    "sections": [{
                        "uuid": "902658ea-b528-4411-affa-f7fee08852ff",
                        "notebookViews": defaultViews(report, 'eswwo_dairy_max_n2o', 313)
                    }]
                },
                {
                    "id": "300d123e-8501-4d67-b6a0-8763f44af54a",
                    "title": "Dairy nitrogen loss",
                    "layerId": 312,
                    "layerName": "eswwo_dairy_max_n",
                    "sections": [{
                        "uuid": "b3afe424-f82e-4d22-9e29-8d3e4bf06af2",
                        "notebookViews": defaultViews(report, 'eswwo_dairy_max_n', 312)
                    }]
                },
                {
                    "id": "148e5253-bef3-47ae-a1b3-bbafb8f89de1",
                    "title": "Estimated Nitrogen Leaching - Ryegrass and Silage Maize",
                    "layerId": 317,
                    "layerName": "eswwo_nleachloss_maize_grass",
                    "sections": [{
                        "uuid": "60a57442-fa47-4ceb-9784-2db50c184966",
                        "notebookViews": defaultViews(report, 'eswwo_nleachloss_maize_grass', 317)
                    }]
                },
                {
                    "id": "7827005d-056e-45a0-9bae-3f7805c6c1f8",
                    "title": "Estimated Nitrogen Leaching - Intensive Vegetables",
                    "layerId": 316,
                    "layerName": "eswwo_nleachloss_intensive_veggies",
                    "sections": [{
                        "uuid": "2bfa9209-b4b4-46fb-b267-7df98c8fec06",
                        "notebookViews": defaultViews(report, 'eswwo_nleachloss_intensive_veggies', 316)
                    }]
                },
                {
                    "id": "b1406449-4ae9-403f-a80d-8eaa4174c537",
                    "title": "Estimated Nitrogen Leaching - Broadacre Vegetables",
                    "layerId": 315,
                    "layerName": "eswwo_nleachloss_broadacre_veggies",
                    "sections": [{
                        "uuid": "3769c0c7-9c95-4804-8681-e1434ad6c676",
                        "notebookViews": defaultViews(report, 'eswwo_nleachloss_broadacre_veggies', 315)
                    }]
                }
            ]
        },
        {
            "id": "06c86136-fd72-487c-9fa1-a582f0a2e821",
            "title": "Freshwater State",
            "topics": [{
                "id": "30bfbec0-9ce8-4a23-aef0-11e597f54706",
                "title": "E. coli excess load",
                "layerId": 314,
                "layerName": "eswwo_ecoli_exyldpct",
                "sections": [{
                    "uuid": "325a31dc-a7cc-4f19-8598-e7c187046ecb",
                    "notebookViews": defaultViews(report, 'eswwo_ecoli_exyldpct', 314)
                }]
            }, {
                "id": "e70901bf-3dd5-4876-92b1-3e5a9c620462",
                "title": "Nitrogen excess load",
                "layerId": 318,
                "layerName": "eswwo_nutr_tn_exyldpct",
                "sections": [{
                    "uuid": "aae965a1-8075-4d01-a725-81228086e7a2",
                    "notebookViews": defaultViews(report, 'eswwo_nutr_tn_exyldpct', 318)
                }]
            }, {
                "id": "fa2b40f6-b0c6-4206-9d4c-663c75a923bd",
                "title": "Phosphorus excess load",
                "layerId": 319,
                "layerName": "eswwo_nutr_tp_exyldpct",
                "sections": [{
                    "uuid": "60bac26f-b5c1-4640-bc66-db0d8aae6891",
                    "notebookViews": defaultViews(report, 'eswwo_nutr_tp_exyldpct', 319)
                }]
            }, {
                "id": "361e9e62-8bf7-4034-8aca-ecfa0a607f71",
                "title": "Sediment excess load",
                "layerId": 320,
                "layerName": "eswwo_sedi_exyldpct",
                "sections": [{
                    "uuid": "e9479cd6-2d35-418e-9452-1bc51aa16e01",
                    "notebookViews": defaultViews(report, 'eswwo_sedi_exyldpct', 320)
                }]
            }]
        },
    ];
}

/** Generated new point query topics with
 WITH layers as (SELECT
 id,
 json_build_object(
 'id', gen_random_uuid()::text,
 'title', conf.description,
 'sections', json_build_array(
 json_build_object(
 'uuid', gen_random_uuid()::text,
 'notebookViews', 'defaultViews(report, ''' || conf.layer_name || ''', ' || conf.id || ')'
 )
 )
 ) as configuration
 FROM data.layer_configuration conf),
 pcs AS (SELECT
 pc.layer_collection_id,
 json_agg(layers.configuration) as topics
 FROM data.portal_collection pc
 JOIN layers ON layers.id = pc.layer_configuration_id
 GROUP BY pc.layer_collection_id
 )
 SELECT json_build_object(
 'title', col.short_name,
 'topics', pcs.topics
 ) FROM data.layer_collection col
 JOIN pcs ON col.id = pcs.layer_collection_id
 WHERE col.id in (36, 35, 34);
 */
